import { getTypePage, getSubTypePage, getSujetPage } from "../analytics/utils";
import { getTracker } from "./tracker-manager";
import { deprecatedGetAccountData } from "../account/account-data/account-data";
import { AccountDataInterface } from "@models/account-data";
import { getAllInstancesByElementName, getSingleInstanceByElement, getSingleInstanceByName } from "../../core";
import CheckMailNewService from "@services/check-mail-new-service";

export abstract class EVENT_TRIGGER {
    static readonly INIT: string = "init";
    static readonly CLICK: string = "click";
    static readonly BLUR: string = "blur";
    static readonly FOCUS: string = "focus";
    static readonly CHANGE: string = "change";
}

export abstract class EVENT_TYPE {
    static readonly GENERIC: string = "generic";
    static readonly GTM: string = "gtm";
    static readonly DATA: string = "data";
    static readonly IDENTIFY: string = "identify";
}

export interface GenericEvent {
    [index: string]: any;
}

export interface GtmEvent {
    [index: string]: any;
}

export interface DataEvent {
    [index: string]: any;
}

export interface IdentifyEvent {
    [index: string]: any;
}

export default class GlobalEvent {
    private dataEvent: DataEvent;
    private gtmEvent: GtmEvent;
    private genericEvent: GenericEvent;
    private identifyEvent: IdentifyEvent;
    private types: Array<EVENT_TYPE>;
    private trigger: EVENT_TRIGGER;
    private follow: string;
    private libelle: string;
    private fired: boolean;
    private notrack: boolean;
    private condition: any;
    private target: any;
    private service: CheckMailNewService;
    
    constructor (data: any, target?: any) {
        // TODO Fix case issue
        this.trigger = data.trigger;
        if (!this.trigger) {
            if (!target) {
                this.trigger = EVENT_TRIGGER.INIT;
            } else {
                this.trigger = EVENT_TRIGGER.CLICK;
            }
        }
        this.follow = data.follow;
        this.libelle = data.libelle ? data.libelle : data.EventLibelle;
        this.fired = false;

        this.types = [];

        // Look if the types are passed in the data
        if (data.types) {
            if (!Array.isArray(data.types)) {
                // In case types are sent in a string
                if ((data.types + "").length) {
                    this.types = data.types.split(", ");
                }
            } else {
                this.types = data.types;
            }
        }

        // If still no types, deduce them from the provided attributes
        if (this.types.length === 0) {
            if (data.event || data.EventAction || data.EventCat || data.EventLibelle || data.ecommerce) {
                this.types.push(EVENT_TYPE.GTM);
            }
            if (data.libelle || data.p || data.url || data.iid || data.it) {
                this.types.push(EVENT_TYPE.DATA);
            }
            if (data.identify) {
                this.types.push(EVENT_TYPE.IDENTIFY);
            }
            if (this.types.length === 0) {
                this.types.push(EVENT_TYPE.GTM);
                this.types.push(EVENT_TYPE.GENERIC);
            }
        }

        // TODO This is TOTAL MADNESS! Destroy everything!
        if (this.types.includes(EVENT_TYPE.GTM)) {
            this.gtmEvent = {};
            if (data.ecommerce) {
                this.gtmEvent.ecommerce = data.ecommerce;
                if (this.gtmEvent.ecommerce.click) {
                    this.gtmEvent.event = data.event ? data.event : "productClick";
                    if (this.gtmEvent.event == "productClick") {
                        this.gtmEvent.EventCat = data.EventCat ? data.EventCat : "Clics";
                    } else {
                        this.gtmEvent.EventCat = data.EventCat ? data.EventCat : data.trigger ? data.trigger + "s" : "Inconnus";
                    }
                    this.gtmEvent.EventLibelle = data.EventLibelle ? 
                        data.EventLibelle : 
                        (getTypePage() + " - Clic sur offre" + (data.ecommerce.id ? (" " + data.ecommerce.id)  : ""));
                    if (this.gtmEvent.event == "productClick") {
                        this.gtmEvent.EventAction = data.EventAction ? data.EventAction : "Clic sur offre";
                    } else {
                        this.gtmEvent.EventAction = data.EventAction ? data.EventAction : (data.trigger ? data.trigger : "Action") + " sur offre";
                    }
                    if (this.gtmEvent.ecommerce.click.products) {
                        for (let oo = 0; oo < this.gtmEvent.ecommerce.click.products.length; oo++) {
                            this.gtmEvent.ecommerce.click.products[oo].dimension74 = 
                                this.gtmEvent.ecommerce.click.products[oo].dimension74 || "classique";
                        }
                    }
                } else {
                    if (this.gtmEvent.ecommerce.impressions) {
                        this.gtmEvent.event = data.event ? data.event : "impressionLoad";
                        this.gtmEvent.EnhancedEcommerce = "true";
                        for (let oo = 0; oo < this.gtmEvent.ecommerce.impressions.length; oo++) {
                            this.gtmEvent.ecommerce.impressions[oo].dimension74 = 
                                this.gtmEvent.ecommerce.impressions[oo].dimension74 || "classique";
                        }
                        if (this.gtmEvent.event != "impressionLoad") {
                            // impression load doesn't need all of the search informations because they are already on the datalayer
                            let idOffre = "";
                            for (let i = 0; i < data.ecommerce.impressions.length; i++) {
                                idOffre += ", " + data.ecommerce.impressions[i].id;
                            }
                            if (idOffre.length > 0) {
                                idOffre = idOffre.substring(2);
                            }
                            this.gtmEvent.idOffre = idOffre;
        
                            this.gtmEvent["Compteur-Offre"] = 
                                (data["Compteur-Offre"] ? data["Compteur-Offre"] : data.totalCount ? data.totalCount : 0) + "";
                            this.gtmEvent["Compteur-Offre-Degroupe"] = (data["Compteur-Offre-Degroupe"] ? 
                                data["Compteur-Offre-Degroupe"] : 
                                data.totalUngroupCount ? data.totalUngroupCount : 0) + "";
                            let resultatRecherche = "[0]";
                            if (data["Resultat-Recherche"] && data["Resultat-Recherche"] != "") {
                                resultatRecherche = data["Resultat-Recherche"];
                            } else {
                                data.totalUngroupCount = parseInt(this.gtmEvent["Compteur-Offre-Degroupe"]);
                                if (data.totalUngroupCount) {
                                    if (data.totalUngroupCount == 1) {
                                        resultatRecherche = "[1]";
                                    } else if (data.totalUngroupCount == 2) {
                                        resultatRecherche = "[2]";
                                    }else if (data.totalUngroupCount > 2 && data.totalUngroupCount < 6) {
                                        resultatRecherche = "[3-5]";
                                    } else if (data.totalUngroupCount > 5 && data.totalUngroupCount < 11) {
                                        resultatRecherche = "[6-10]";
                                    } else if (data.totalUngroupCount > 10 && data.totalUngroupCount < 16) {
                                        resultatRecherche = "[11-15]";
                                    } else if (data.totalUngroupCount > 15 && data.totalUngroupCount < 31) {
                                        resultatRecherche = "[16-30]";
                                    } else if (data.totalUngroupCount > 30 && data.totalUngroupCount < 51) {
                                        resultatRecherche = "[31-50]";
                                    } else if (data.totalUngroupCount > 50 && data.totalUngroupCount < 101) {
                                        resultatRecherche = "[51-100]";
                                    } else if (data.totalUngroupCount > 100) {
                                        resultatRecherche = "[101+]";
                                    }
                                }
                            }
                            this.gtmEvent["Resultat-Recherche"] = resultatRecherche;
                            
                            this.gtmEvent.Departement = data.Departement ? data.Departement : "";
                            this.gtmEvent.Domaine = data.Domaine ? data.Domaine : "";
                            this.gtmEvent.Region = data.Region ? data.Region : "";
                            this.gtmEvent.Ville = data.Ville ? data.Ville : "";
                            
                            this.gtmEvent.searchFonction = data.searchFonction ? 
                                data.searchFonction.toLowerCase() : data.searchCategorie ? 
                                data.searchCategorie.toLowerCase() : "";
                            this.gtmEvent.searchLocalite = data.searchLocalite ? data.searchLocalite : "";
                            this.gtmEvent.searchTypeContrat = data.searchTypeContrat ? data.searchTypeContrat : "";
                            this.gtmEvent.searchQuoi = data.searchQuoi ? data.searchQuoi : "";
                            this.gtmEvent.searchOu = data.searchOu ? data.searchOu : "";
                            this.gtmEvent.searchCategorie = data.searchCategorie ? data.searchCategorie : ""; // 1 ou 2
                            this.gtmEvent.searchSecteur = data.searchSecteur ? data.searchSecteur : "";
                            this.gtmEvent.searchQualification = data.searchQualification ? data.searchQualification : "";
                            this.gtmEvent.searchExperience = data.searchExperience ? data.searchExperience : "";
                            this.gtmEvent.searchTypeEntreprise = data.searchTypeEntreprise ? data.searchTypeEntreprise : "";
                            this.gtmEvent.searchDate = data.searchDate ? data.searchDate : "";
                            this.gtmEvent.searchRayon = data.searchRayon ? data.searchRayon : "";
        
                            this.gtmEvent.categoryPage = data.categoryPage ? data.categoryPage : getTypePage();
                            this.gtmEvent.sujetPage = data.sujetPage ? data.sujetPage : getSujetPage();
                            this.gtmEvent.typePage =  data.typePage ? data.typePage : getSubTypePage();
                        } else {
                            this.notrack = (this.gtmEvent.ecommerce.impressions.length <= 0);
                        }
                    } else {
                        if (this.gtmEvent.ecommerce.purchase && this.gtmEvent.ecommerce.purchase.products) {
                            for (let oo = 0; oo < data.ecommerce.purchase.products.length; oo++) {
                                this.gtmEvent.ecommerce.purchase.products[oo].dimension74 = 
                                    this.gtmEvent.ecommerce.purchase.products[oo].dimension74 || "classique";
                            }
                        }
                    }
                }
            } else {
                this.gtmEvent.event = data.event ? data.event : "EventGeneric";
                if (this.gtmEvent.event != "purchase") {
                    this.gtmEvent.EventCat = 
                        data.EventCat ? data.EventCat : data.trigger ? data.trigger + "s" : "Inconnus";
                    this.gtmEvent.EventLibelle = data.EventLibelle ? 
                        data.EventLibelle : 
                        document.title + (target ? " - " + (target.element.value ? target.element.value : target.element.innerText) : "");
                    this.gtmEvent.EventAction = 
                        data.EventAction ? data.EventAction : (data.trigger ? data.trigger : "Action") + " sur bouton";
                } else {
                    if (this.gtmEvent.items) {
                        for (let oo = 0; oo < this.gtmEvent.items.length; oo++) {
                            this.gtmEvent.items[oo].dimension74 = 
                                this.gtmEvent.items[oo].dimension74 || "classique";
                        }
                    }
                }
                
            }
            for (const k in data) {
                if (k !== "trigger") {
                    if (!this.gtmEvent[k]) {
                        this.gtmEvent[k] = data[k];
                    }
                }
            }
        }

        if (this.types.includes(EVENT_TYPE.DATA)) {
            this.dataEvent = {};
            this.dataEvent.libelle = data.libelle ? 
                data.libelle : 
                document.title + (target ? " - " + (target.element.value ? target.element.value : target.element.innerText) : "");
            this.dataEvent.p = data.p;
            this.dataEvent.url = data.url;
            this.dataEvent.it = data.it;
            this.dataEvent.iid = data.iid;
            if (!this.dataEvent.url && (this.dataEvent.iid || this.dataEvent.it)) {
                this.dataEvent.url = location.origin + (target ? target.element.href : "");
            }
        }
    
        if (this.types.includes(EVENT_TYPE.IDENTIFY)) {
            this.identifyEvent = {};
        }
    
        if (this.types.includes(EVENT_TYPE.GENERIC)) {
            this.genericEvent = {};
            this.genericEvent.event = data.event ? data.event : "EventGeneric";
            this.genericEvent.EventCat = data.EventCat ? data.EventCat : data.trigger ? data.trigger + "s" : "Inconnus";
            this.genericEvent.EventLibelle = data.EventLibelle ? 
                data.EventLibelle : 
                document.title + (target ? " - " + (target.element.value ? target.element.value : target.element.innerText) : "");
            this.genericEvent.EventAction = data.EventAction ? 
                data.EventAction : 
                (data.trigger ? data.trigger : "Action") + " sur bouton";
            this.genericEvent.libelle = data.libelle ? 
                data.libelle : 
                document.title + (target ? " - " + (target.element.value ? target.element.value : target.element.innerText) : "");
            this.genericEvent.p = data.p ? data.p : "";
            this.genericEvent.url = data.url ? data.url : "";
            this.genericEvent.it = data.it ? data.it : "";
            this.genericEvent.iid = data.iid ? data.iid : "";
        }

        if (data.condition) {
            this.condition = data.condition;
        }
        if (target) {
            this.target = target;
        }

        this.init();
    }

    /**
     * Set listeners for triggered events
     */
    private init() {
        if (this.trigger === EVENT_TRIGGER.INIT) {
            if (this.condition && (this.condition.RoUrlIsActive !== undefined)) {
                // Wait for account data
                PubSub.subscribe("account-data", () => {
                    this.track();
                });
            } else {
                // Track immediatly
                this.track();
            }            
        } else if (this.target) {
            // Listen to target tracking event
            this.target.element.addEventListener(this.trigger, (event: Event) => {
                // Return if Ctrl key is pressed
                if (this.trigger === EVENT_TRIGGER.CLICK && (<MouseEvent> event).ctrlKey) {
                    return;
                }

                if (this.trigger === EVENT_TRIGGER.CHANGE && this.gtmEvent) {
                    // Set change value in the event
                    this.gtmEvent.EventLibelle = this.libelle + "/" + this.target.element.value;
                }

                this.track();
            });
        }
    }

    track() {
        if (!this.notrack && !this.fired) {
            this.fired = true;

            const trackCallback = () => {
                 // Track per event types
                if (this.dataEvent) {
                    getTracker(EVENT_TYPE.DATA).track(this.dataEvent);
                }
                if (this.gtmEvent) {
                    getTracker(EVENT_TYPE.GTM).track(this.gtmEvent);
                }
                if (this.identifyEvent) {
                    getTracker(EVENT_TYPE.IDENTIFY).track(this.identifyEvent);
                }
                if (this.genericEvent) {
                    getTracker(EVENT_TYPE.GENERIC).track(this.genericEvent);
                }

                if (this.target) {
                    if (this.follow) {
                        if (this.follow === "nofollow") {
                            this.follow = undefined;
                        } else if (this.follow === "follow") {
                            this.follow = this.target.element.href;
                        } 
                    } else {
                        this.follow = this.target.element.href;
                    }

                    // Redirect if needed
                    if (this.follow && this.trigger === EVENT_TRIGGER.CLICK) {
                            window.location = this.target.element.href;
                    }
                }
            }
            this.isValid(trackCallback); 
        }
    }

    /**
     * Check event validity
     */
    private isValid(callback: any) {
        let isValid = true;
        
        if(this.condition !== undefined) {
          // Check if there is a condition for the event
          if (typeof this.condition.RoUrlIsActive !== "undefined") {
            let test = false;
            const accountData: AccountDataInterface = deprecatedGetAccountData();
            test = accountData?.RoUrlIsActive;
            isValid = test === this.condition.RoUrlIsActive;
          }
          if(isValid && (typeof this.condition.isOkEmail !== "undefined" || typeof this.condition.isEmailExist !== "undefined")) {
               let test = false;
               let found = false;
               const searchInstance =
                 getSingleInstanceByElement("ValidatedInput",this.target.element);
              if(searchInstance) {
                   if (this.target.element.getAttribute("type") == "email") {
                     found = true;
                     test = searchInstance.isValid();
                   }
              }   
              if(!found) {
                  const inputmail = document.querySelectorAll('[type="email"]')[0] as HTMLInputElement;
                  if(inputmail) {
                     if (inputmail.value && inputmail.value != "") {
                        const name = inputmail.name;
                        const searchInstance = getAllInstancesByElementName("ValidatedInput", name)
                        for(const instance of searchInstance) {
                            test = instance.isValid();
                        }
                    }
                  }
              }
              if (typeof this.condition.isOkEmail != "undefined") {
                isValid = test == this.condition.isOkEmail;
              } else {
                isValid = test;
              }
          }
          if(isValid && typeof this.condition.checked != "undefined") {
               if (this.target.nodeName == "INPUT" && this.target.hasAttribute("type") && this.target.getAttribute("type") == "checkbox") {
                    const test = this.target.checked + "";
                    isValid = test == this.condition.checked;
                }
          }
          if(isValid && typeof this.condition.isEmailExist != "undefined") {              
                const inputmail = document.querySelector('[type="email"]') as HTMLInputElement;
                const checkEmailUrl = "/Compte/CheckEmailIfNew";
                this.service = new CheckMailNewService(checkEmailUrl);
                this.service.post({"Email" : inputmail.value, "checkDummyState" : false}, (response:any) => {
                     isValid = !(response.newUser == this.condition.isEmailExist);
                     if (isValid) {
                        callback()
                     }
                })
        }
        if (isValid) {
            callback()
        }

    } else {
        callback()
    }
   }
}